import(/* webpackMode: "eager" */ "/vercel/path0/src/app/equipe/page.tsx");
